import type { PersonalInformationFormData } from "Components/Onboarding/shared/Hooks/usePersonalInformationValidation";
import { AddressType, type PartyDto } from "Infrastructure/Api/Api";
import { getPartyWithSingleAddress } from "Components/Onboarding/utils";
import type { DeepPartial } from "react-hook-form";

export const getPersonalInformationFormData = (
  party: PartyDto,
): DeepPartial<PersonalInformationFormData> => {
  const { address } = getPartyWithSingleAddress(party, AddressType.Permanent);

  return {
    ...party,
    firstName: party.firstName ?? "",
    lastName: party.lastName ?? "",
    companyName: party.companyName ?? "",
    taxNumber: party.taxNumber ?? "",
    companyNumber: party.companyNumber ?? "",
    personalNumber: party.personalNumber ?? "",
    birthDate: party.birthDate ?? "",
    gender: party.gender,
    birthPlace: party.birthPlace ?? "",
    nationality: party.nationality ?? undefined,
    otherNationalities: party.otherNationalities,
    hasOtherNationality: party.otherNationalities.length > 0,
    isVATPayer: party.isVATPayer ?? false,
    address: {
      ...address,
      street: address.street ?? undefined,
      streetNumber: address.streetNumber ?? undefined,
      orientationNumber: address.orientationNumber ?? undefined,
      postalCode: address.postalCode ?? undefined,
      municipality: address.municipality ?? undefined,
    },
  };
};
